<template>
    <div>
        <app-erros-box
            :erros="['PROJETO INDISPONÍVEL']"
            v-if="!projeto"
        ></app-erros-box>
        <projeto-detalhar
            :projeto="projeto"
            v-if="projeto"
        >
            <template slot="footer">
                <slot name="projetoFooter"></slot>
                    <b-button
                        v-if="$temAcessoView('SGTEC-PROJ-ANX-00')"
                        variant="primary"
                        class="ml-2"
                        @click.stop="mostrarAnexos = true"
                        ><i class="fa fa-paperclip"></i> Anexos
                    </b-button>
            </template>
        </projeto-detalhar>
        <projeto-anexos
            v-if="mostrarAnexos"
            :projeto="projeto"
            @fechar="mostrarAnexos = false"
        ></projeto-anexos>
        <etapas
            :projeto="projeto"
            :etapas="etapas"
            :servicos="servicos"
            :rotaRateio="rotaRateio"
            :rotaDetalhar="rotaDetalhar"
            :permiteAcessoRateio="permiteAcessoRateio"
            :permiteAcessoDetalhar="permiteAcessoDetalhar"
            :permiteExcluirComprometimento="permiteExcluirComprometimento"
            :permiteAcessoErroComprometimento="permiteAcessoErroComprometimento"
            :permiteAcessoHistorico="permiteAcessoHistorico"
            @obterAtualizacao="$emit('obterAtualizacao')"
            v-if="projeto"
        >
            <template slot="etapaAcoes" slot-scope="data">
                <slot name="etapaAcoes" v-bind="data"></slot>
            </template>
        </etapas>
    </div>
</template>

<script>
import ProjetoDetalhar from './ProjetoDetalhar'
import ProjetoAnexos from './ProjetoAnexos'
import Etapas from './../etapas/Etapas'

export default {
    props: {
        projeto: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object,
            default: () => ({})
        },

        rotaRateio: {
            type: String
        },

        rotaDetalhar: {
            type: String
        },

        permiteAcessoRateio: {
            type: Boolean,
            default: () => false
        },

        permiteAcessoDetalhar: {
            type: Boolean,
            default: () => false
        },

        permiteExcluirComprometimento: {
            type: Boolean,
            default: () => false
        },

        permiteAcessoErroComprometimento: {
            type: Boolean,
            default: () => false
        },

        permiteAcessoHistorico: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            mostrarAnexos: false
        }
    },

    methods: {},

    computed: {
        etapas() {
            return this.projeto.etapas
        }
    },

    created() {},

    components: {
        ProjetoDetalhar,
        Etapas,
        ProjetoAnexos
    }
}
</script>
